import DataTable from "../../Reusable/DataTable";
import NACell from "../../Reusable/DataTable/NACell";
import APIS from "../../../constant/EndPoint";
import TableActionButton from "../../Reusable/TableActionButton";

const PaymentMethodList = () => {

  const defaultColumns: any = [
    {
      header: "S.N",
      accessorKey: ".",
      cell: ({ row }: any) => <>{row?.index + 1}</>,
    },
    {
      header: "Name",
      accessorKey: "name",
      cell: NACell,
    },

    {
      header: "Action",
      accessorKey: "id",
      cell: ({ row, getValue }: any) => (
        <>
          <TableActionButton editPath={`edit/${getValue()}`} />
        </>
      ),
    },
  ];
  return (
    <DataTable
      url={APIS.PAYMENT_METHOD_TYPE}
      queryKey={"payment-method-type"}
      columns={defaultColumns}
      addNewPagePath={"/create-payment-method"}
      tableName={"Payment Method"}
    />
  );
};

export default PaymentMethodList;
